import {
	VOUCHER_REQUEST_GET,
	VOUCHER_RESPONSE_GET_FAIL,
	VOUCHER_RESPONSE_GET_SUCCESS,
	VOUCHER_ADD_MODAL,
	VOUCHER_ADD_MODAL_ALERT,
	VOUCHER_REQUEST_POST,
	VOUCHER_RESPONSE_POST_FAIL,
	// DELETE_VOUCHER_RESET_SUCCESS_MSG_OR_ERROR,
	VOUCHER_REQUEST_PATCH,
	VOUCHER_RESPONSE_PATCH_FAIL,
	DELETE_VOUCHER_RESPONSE_SUCCESS,
	VOUCHER_SELECTED,
	RESET_VOUCHER_DELETE,
	DELETE_ACTION_TRIGGERED,
	ADD_VOUCHER_RESPONSE_SUCCESS,
	RESET_VOUCHER_ADD,
	VOUCHER_CODE_MODAL,

} from '../constants/voucherConstants';

export const voucherCodeModalReducer = (
    state = {
        voucherCodeModal: false,
    }, 
    action
) => {
	switch (action.type) {
		case VOUCHER_CODE_MODAL:
			return{
				...state,
				voucherCodeModal: action.payload,
			}
		default:
			return state;
	}
};

export const voucherSelectedReducer = (
    state = {
        voucherSelected : {},
		deleteActionTriggered: false,
		voucherLoading:false,
    }, 
    action
) => {
	switch (action.type) {
		case VOUCHER_SELECTED:
			return { 
                ...state,
                voucherSelected: action.payload
            };
		case DELETE_ACTION_TRIGGERED:
			return{
				...state,
				deleteActionTriggered: action.payload,
			}
		default:
			return state;
	}
};


export const voucherListReducer = (state = { vouchers: {}  }, action) => {
	switch (action.type) {
		case VOUCHER_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case VOUCHER_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				vouchers: action.payload,
			};
		case VOUCHER_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

// export const voucherReducer = (
//     state = {
//         voucherSelected : {},
//     }, 
//     action
// ) => {
// 	switch (action.type) {
// 		case VOUCHER_SELECTED:
// 			return { 
//                 ...state,
//                 voucherSelected: action.payload
//             };
// 		default:
// 			return state;
// 	}
// };

export const voucherAddModalReducer = (
	state = {
		voucherAddModal: false,
		voucherAddModalAlert: true,
		// voucherAddModalOnSave:false,
	},
	action
) => {
	switch (action.type) {
		case VOUCHER_ADD_MODAL:
			return {
				...state,
				voucherAddModal: action.payload,
			};
		case VOUCHER_ADD_MODAL_ALERT:
			return {
				...state,
				voucherAddModalAlert: action.payload,
			};
		default:
			return state;
	}
};

export const voucherAddReducer = (
	state = { msg: null, error: null, data: [], loading: false },
	action
) => {
	switch (action.type) {
		case VOUCHER_REQUEST_POST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case VOUCHER_RESPONSE_POST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
			case ADD_VOUCHER_RESPONSE_SUCCESS:
				return{
					...state,
					loading: false,
					...action.payload,
				}
				case RESET_VOUCHER_ADD: 
				return {
					...state,
					loading: false,
					msg: null,
					error: null,
					data: []
				}
		// case DELETE_VOUCHER_RESET_SUCCESS_MSG_OR_ERROR:
		// 	return {
		// 		...state,
		// 		...action.payload,
		// 	};
		default:
			return state;
	}
};

export const voucherDeleteReducer = (
	state = {
		successMessageOnDelete: null,
		deleteError: null,
		data: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case VOUCHER_REQUEST_PATCH:
			return {
				...state,
				loading: true,
				deleteError: null,
			};
		case VOUCHER_RESPONSE_PATCH_FAIL:
			return {
				...state,
				loading: false,
				deleteError: action.payload,
			};
		case DELETE_VOUCHER_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_VOUCHER_DELETE: 
			return {
				...state,
				loading: false,
				successMessageOnDelete: null,
				deleteError: null,
				data: []
			}
		// case DELETE_GROUP_RESET_SUCCESS_MSG_OR_ERROR:
		// 	return {
		// 		...state,
		// 		...action.payload,
		// 	};
		default:
			return state;
	}
};

